import axios from 'axios';
import React, { useCallback, useState } from 'react';
import AuthField from './components/AuthField';
import AuthForm from './components/AuthForm';
import AuthPageWrapper from './components/AuthPageWrapper';
import { escape } from 'lodash';

export default function ForgotPassword({ navTo, resetConfig }) {
  const [email, setEmail] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [alert, setAlert] = useState({ open: false, message: '', severity: 'error' });

  const handleSubmit = useCallback(
    async (e) => {
      e.preventDefault();
      setAlert((prev) => ({ ...prev, open: false }));
      setIsLoading(true);
      resetConfig();
      try {
        const { data } = await axios.post(
          '/sendPasswordReset',
          { email },
          { validateStatus: () => true }
        );
        if (data.redirect) {
          setAlert({ open: true, message: 'Password reset link sent.', severity: 'success' });
          await navTo(`forgotPasswordSuccess`, { email: escape(email) });
        } else {
          setAlert({ open: true, message: data.error || 'Request failed.', severity: 'error' });
        }
      } catch {
        setAlert({ open: true, message: 'Server error. Try again later.', severity: 'error' });
      } finally {
        setIsLoading(false);
      }
    },
    [email, navTo, resetConfig]
  );

  return (
    <AuthPageWrapper
      alert={alert}
      onCloseAlert={() => setAlert((prev) => ({ ...prev, open: false }))}
    >
      <AuthForm
        disableSubmit={!email}
        isLoading={isLoading}
        onCancel={() => navTo('login')}
        onSubmit={handleSubmit}
        sectionTitle="Reset Password"
        submitText={isLoading ? 'Processing...' : 'Submit Request'}
        subtitle="Enter the email address associated with your account."
      >
        <AuthField
          disabled={isLoading}
          label="Email Address"
          onChange={(e) => setEmail(e.target.value)}
          type="email"
          value={email}
        />
      </AuthForm>
    </AuthPageWrapper>
  );
}
